/**
 * How far past its box the parallax banner is scaled.
 *
 * The photograph lags the scroll, and without the overscale that lag would
 * drag an edge into view. It rests at this scale — the transform is written on
 * mount, not only once the reader moves — so anything that has to end up
 * matching the banner has to end up here too, not at 1.
 */
export const BANNER_PARALLAX_SCALE = 1.14;

/**
 * The banner's bottom legibility scrim.
 *
 * Shared so an overlay that hands over to the banner can carry the same one:
 * without it the gradient appears at the moment of handover, which reads as
 * the picture changing rather than the overlay leaving.
 */
export const BANNER_SCRIM =
    'bg-linear-to-t absolute inset-x-0 bottom-0 h-[62%] from-[#131313] via-[#131313]/55 to-transparent opacity-[0.9]';
